import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Fr from '../views/Fr.vue'
import Jp from '../views/Jp.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/fr',
    name: 'Fr',
    component: Fr
  },
  {
    path: '/jp',
    name: 'Jp',
    component: Jp
  },
  { path: '/:pathMatch(.*)*', component: Home }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
